export default {
      id: "open-new-tab-usage",
      viewBox: "0 0 22 20",
      url: __webpack_public_path__ + "img/icons.svg#open-new-tab",
      toString: function () {
        return this.url;
      }
    }